import React from 'react';

const SkipperContent = () => {
    //console.log(window.location.href);
    return <a href='#mainContent' className='skipContent'>Skip Content</a>;
};

export default SkipperContent;